export const CoreAgentConversationTitlesName = 'CoreAgentConversationTitles';
